export default __webpack_public_path__ + "static/media/adminbg.695de47d.png";